import { createFormContext, type UseForm } from '@mantine/form';

import type { CreateAutomationVariables } from '../../../api';

const [AutomationWizardFormProvider, useAutomationWizardFormContext, useForm] =
  createFormContext<CreateAutomationVariables>();

export { AutomationWizardFormProvider, useAutomationWizardFormContext };
export const useAutomationWizardForm: UseForm<CreateAutomationVariables> = useForm;
